import { List, Position, Rhythm, Text, TextSmall } from '@trmediaab/zebra';
import { Check } from '@trmediaab/zebra-icons';

import AltContentDivider from '../AltContentDivider';

interface DetailItemProps {
  headline: string;
  text?: string;
  iconColor?: string;
}

const DetailItem = ({ headline, text, iconColor }: DetailItemProps) => (
  <List.listItem textAlign="left">
    <Position.relative pl="4">
      <Position.absolute top="-2px" left="0">
        <Check size="20px" color={iconColor} />
      </Position.absolute>

      <Text.strong fontWeight="semiBold">{headline}</Text.strong>

      {headline && text && <br />}

      {text && <TextSmall display="block">{text}</TextSmall>}
    </Position.relative>
  </List.listItem>
);

interface ProductBulletListProps {
  items: DetailItemProps[];
  additionalItemsHeadline?: string;
  additionalItems?: DetailItemProps[];
  iconColor?: string;
}

const ProductBulletList = ({
  items,
  additionalItemsHeadline,
  additionalItems,
  iconColor = 'checkout.icon1',
}: ProductBulletListProps) => (
  <Rhythm between="3">
    <List gap="2">
      {items.map(item => (
        <DetailItem
          key={item.headline}
          headline={item.headline}
          text={item.text}
          iconColor={iconColor}
        />
      ))}
    </List>
    {additionalItemsHeadline && (
      <AltContentDivider
        text={additionalItemsHeadline}
        subtle={false}
        leftAligned
      />
    )}
    {additionalItems && (
      <List gap="2">
        {additionalItems.map(item => (
          <DetailItem
            key={item.headline}
            headline={item.headline}
            text={item.text}
            iconColor={iconColor}
          />
        ))}
      </List>
    )}
  </Rhythm>
);

export default ProductBulletList;
